import { useEffect, useState } from "react";

const links = [
  { href: "#profile", label: "快速档案" },
  { href: "#updates", label: "近况动态" },
  { href: "#topics", label: "热议话题" },
  { href: "#details", label: "资料详情" },
  { href: "#social", label: "社交动态" },
  { href: "#faq", label: "常见问答" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-lg text-lg transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-vip-diamond-line" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading font-bold text-lg tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            松下纱荣子
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`px-3 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-foreground-950/20"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer text-2xl ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-4 pt-2">
          <div className="grid grid-cols-2 gap-2">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm rounded-md bg-background-100 text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}